import { createUseStyles } from '@glu/theming';

const styles = {
  countWrapper: {
    '& label': {
      marginBottom: 0,
      '& p': {
        margin: 0,
      },
    },
    '& select': {
      minWidth: 75,
    },
    marginRight: 24,
  },
};

export default createUseStyles(styles);
